import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Scrollbars } from 'react-custom-scrollbars';

import './styles.scss';

class ScrollBarsCustom extends Component {
    handlers = [];

    static childContextTypes = {
        addScrollBarHandler: PropTypes.func,
        removeScrollBarHandler: PropTypes.func,
    };

    constructor(props) {
        super(props);
        this.innerRef = React.createRef();
    }

    getChildContext = () => ({
        addScrollBarHandler: this.addScrollBarHandler,
        removeScrollBarHandler: this.removeScrollBarHandler,
    });

    scrollTop = (top) => {
        if (this.innerRef && this.innerRef.current) {
            const scrollbar = this.innerRef.current;
            scrollbar.scrollTop(top);
        }
    };

    getScrollTop = () => {
        if (this.innerRef && this.innerRef.current) {
            const scrollbar = this.innerRef.current;
            return scrollbar.getScrollTop();
        }
        return 0;
    };

    getClientHeight = () => {
        if (this.innerRef && this.innerRef.current) {
            const scrollbar = this.innerRef.current;
            return scrollbar.getClientHeight();
        }
        return 0;
    };

    addScrollBarHandler = (handler) => {
        this.handlers.push(handler);
    };

    removeScrollBarHandler = (handler) => {
        const index = this.handlers.indexOf(handler);
        if (index !== -1) {
            this.handlers.splice(index, 1);
        }
    };

    onScrollFrame = (values) => {
        const { onScrollFrame } = this.props;
        if (onScrollFrame) {
            onScrollFrame(values);
        }
        this.handlers.forEach((handler) => {
            handler(values);
        });
    };

    renderFadeTop = () => {
        const { fadeTop, fadeTopHeight = 0 } = this.props;

        if (!fadeTop) return null;

        const style = {};
        if (fadeTopHeight) style.height = fadeTopHeight;

        return <div className="fm-scrollbars__top-fade" style={style} />;
    };

    renderFadeBottom = () => {
        const { fadeBottom, fadeBottomHeight = 0 } = this.props;

        if (!fadeBottom) return null;

        const style = {};
        if (fadeBottomHeight) style.height = fadeBottomHeight;

        return <div className="fm-scrollbars__bottom-fade" style={style} />;
    };

    render() {
        const { children, fadeTop, fadeBottom, style = {}, ...props } = this.props;

        const classNamesFmScrollbars = ['fm-scrollbars'];
        if (fadeTop || fadeBottom) classNamesFmScrollbars.push('fm-scrollbars__with-fade');

        return (
            <div className={classNamesFmScrollbars.join(' ')} style={style}>
                <Scrollbars {...props} onScrollFrame={this.onScrollFrame} ref={this.innerRef}>
                    {children}
                </Scrollbars>
                {this.renderFadeTop()}
                {this.renderFadeBottom()}
            </div>
        );
    }
}

ScrollBarsCustom.propTypes = {
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    fadeBottom: PropTypes.bool,
    fadeBottomHeight: PropTypes.number,
    fadeTop: PropTypes.bool,
    fadeTopHeight: PropTypes.number,
    onScrollFrame: PropTypes.func,
    style: PropTypes.shape({}),
};

export default ScrollBarsCustom;
